export default "__VITE_ASSET__81a4ab51__$_?component__"